import '@/styles/globals.css'
import '@fontsource/playfair-display/400.css'
import '@fontsource/playfair-display/500.css'

import type { CSSProperties, FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import { Geist, Geist_Mono } from 'next/font/google'

const geistSans = Geist({
    variable: '--font-sans',
    subsets: ['latin']
})

const geistMono = Geist_Mono({
    variable: '--font-geist-mono',
    subsets: ['latin']
})

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div
            className={`${geistSans.variable} ${geistMono.variable} h-full font-sans antialiased`}
            style={{ '--font-geist-sans': 'var(--font-sans)' } as CSSProperties}
        >
            <Component {...pageProps} />
        </div>
    )
}

export default App
